/**
 * DoctorProfile.jsx
 * Same as AssistantProfile
 */

import { useState, useEffect } from "react";
//import Avatar from "../../components/Avatar";
import { apiFetch } from "../../components/helpers";

function FeedbackMsg({ text, ok = true }) {
  if (!text) return null;
  return (
    <div
      className={`alert alert-${ok ? "success" : "danger"} py-2 px-3 mb-3`}
      style={{ fontSize: 12 }}
    >
      {text}
    </div>
  );
}

function SectionCard({ title, subtitle, children }) {
  return (
    <div
      className="card border-0 shadow-sm mb-4"
      style={{
        borderRadius: 16,
      }}
    >
      <div
        className="card-header border-0 px-4 py-3"
        style={{
          background: "#FAFBFC",
        }}
      >
        <h6 className="fw-bold mb-1">{title}</h6>
        <p
          className="text-muted mb-0"
          style={{
            fontSize: 12,
          }}
        >
          {subtitle}
        </p>
      </div>

      <div className="card-body px-4 py-4">{children}</div>
    </div>
  );
}

export default function DoctorProfile() {
  const authUser = (() => {
    try {
      return JSON.parse(localStorage.getItem("adminuser") || "{}");
    } catch {
      return {};
    }
  })();

  const doctorId = localStorage.getItem("LoginId");

  const [profile, setProfile] = useState(null);

  const [loading, setLoading] = useState(true);

  const [profileForm, setProfileForm] = useState({
    name: "",
    mobile: "",
    specialization: "",
    experience_years: "",
    qualification: "",
    consultation_fees: "",
  });

  const [pwForm, setPwForm] = useState({
    current_password: "",
    new_password: "",
    confirm_password: "",
  });

  const [profileMsg, setProfileMsg] = useState({
    text: "",
    ok: true,
  });

  const [pwMsg, setPwMsg] = useState({
    text: "",
    ok: true,
  });

  const [saving, setSaving] = useState(false);

  const [pwSaving, setPwSaving] = useState(false);

  const load = async () => {
    setLoading(true);
    let newdoctorId = localStorage.getItem("drId");
    try {
      const json = await apiFetch(process.env.REACT_APP_GET_DOCTOR_PROFILE, {
        method: "POST",
        body: {
          doctor_id: newdoctorId,
        },
      });

      if (json?.status) {
        const d = json.data;

        setProfile(d);

        setProfileForm({
          name: d.name || "",
          mobile: d.mobile || "",
          specialization: d.specialization || "",
          experience_years: d.experience_years || "",
          qualification: d.qualification || "",
          consultation_fees: d.consultation_fees || "",
        });
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    load();
  }, []);

  const saveProfile = async () => {
     let doctorId = localStorage.getItem("drId");
    setSaving(true);
    setProfileMsg({
      text: "",
      ok: true,
    });

    try {
      const json = await apiFetch(process.env.REACT_APP_UPDATE_DOCTOR, {
        method: "POST",
        body: {
          doctor_id: doctorId,
          ...profileForm,
        },
      });

      setProfileMsg({
        text: json.status ? "Profile updated!" : json.message,
        ok: json.status,
      });

      if (json.status) load();
    } catch {
      setProfileMsg({
        text: "Network error",
        ok: false,
      });
    }

    setSaving(false);
  };

  const savePassword = async () => {
    let admin_id = localStorage.getItem("adminId");

    if (pwForm.new_password !== pwForm.confirm_password) {
      return setPwMsg({
        text: "Passwords do not match",
        ok: false,
      });
    }

    setPwSaving(true);

    try {
      const json = await apiFetch(process.env.REACT_APP_UPDATE_ADMIN_PASSWORD || "update_admin_password.php", {
        method: "POST",
        body: {
          admin_id,
          current_password: pwForm.current_password,
          new_password: pwForm.new_password,
        },
      });

      setPwMsg({
        text: json.status ? "Password updated!" : json.message,
        ok: json.status,
      });

      if (json.status) {
        setPwForm({
          current_password: "",
          new_password: "",
          confirm_password: "",
        });
      }
    } catch {
      setPwMsg({
        text: "Network error",
        ok: false,
      });
    }

    setPwSaving(false);
  };

  const inp = "form-control";

  return (
    <div className="p-4">
      <h4 className="fw-bold mb-1">My Profile</h4>

      <p className="text-muted mb-4">Manage doctor profile</p>

      <div className="card shadow-sm border-0 mb-4 p-4">
        <div className="d-flex gap-4 align-items-center">
          <div
            className="rounded-circle d-flex align-items-center justify-content-center text-white fw-bold"
            style={{
              width: 72,
              height: 72,
              fontSize: 24,
              background: "#0d6efd",
            }}
          >
            {profile?.name ? profile.name.charAt(0).toUpperCase() : "D"}
          </div>

          <div>
            <h5 className="fw-bold mb-1">{profile?.name}</h5>

            <p className="text-muted mb-1">{profile?.email}</p>

            <p className="mb-0 text-primary fw-bold">
              {profile?.specialization}
            </p>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="spinner-border" />
      ) : (
        <>
          <SectionCard title="Edit Profile" subtitle="Update doctor details">
            <div className="row g-3">
              <div className="col-md-6">
                <input
                  className={inp}
                  placeholder="Name"
                  value={profileForm.name}
                  onChange={(e) =>
                    setProfileForm({
                      ...profileForm,
                      name: e.target.value,
                    })
                  }
                />
              </div>

              <div className="col-md-6">
                <input
                  className={inp}
                  placeholder="Mobile"
                  value={profileForm.mobile}
                  onChange={(e) =>
                    setProfileForm({
                      ...profileForm,
                      mobile: e.target.value,
                    })
                  }
                />
              </div>

              <div className="col-md-6">
                <input
                  className={inp}
                  placeholder="Specialization"
                  value={profileForm.specialization}
                  onChange={(e) =>
                    setProfileForm({
                      ...profileForm,
                      specialization: e.target.value,
                    })
                  }
                />
              </div>

              <div className="col-md-6">
                <input
                  className={inp}
                  placeholder="Experience"
                  value={profileForm.experience_years}
                  onChange={(e) =>
                    setProfileForm({
                      ...profileForm,
                      experience_years: e.target.value,
                    })
                  }
                />
              </div>

              <div className="col-md-6">
                <input
                  className={inp}
                  placeholder="Qualification"
                  value={profileForm.qualification}
                  onChange={(e) =>
                    setProfileForm({
                      ...profileForm,
                      qualification: e.target.value,
                    })
                  }
                />
              </div>

              <div className="col-md-6">
                <input
                  className={inp}
                  placeholder="Fees"
                  value={profileForm.consultation_fees}
                  onChange={(e) =>
                    setProfileForm({
                      ...profileForm,
                      consultation_fees: e.target.value,
                    })
                  }
                />
              </div>
            </div>

            <div className="mt-3">
              <FeedbackMsg text={profileMsg.text} ok={profileMsg.ok} />

              <button
                className="btn btn-primary"
                onClick={saveProfile}
                disabled={saving}
              >
                Save Changes
              </button>
            </div>
          </SectionCard>

          <SectionCard title="Change Password" subtitle="Update login password">
            <div className="row g-3">
              <div className="col-12">
                <input
                  type="password"
                  className={inp}
                  placeholder="Current Password"
                  value={pwForm.current_password}
                  onChange={(e) =>
                    setPwForm({
                      ...pwForm,
                      current_password: e.target.value,
                    })
                  }
                />
              </div>

              <div className="col-md-6">
                <input
                  type="password"
                  className={inp}
                  placeholder="New Password"
                  value={pwForm.new_password}
                  onChange={(e) =>
                    setPwForm({
                      ...pwForm,
                      new_password: e.target.value,
                    })
                  }
                />
              </div>

              <div className="col-md-6">
                <input
                  type="password"
                  className={inp}
                  placeholder="Confirm Password"
                  value={pwForm.confirm_password}
                  onChange={(e) =>
                    setPwForm({
                      ...pwForm,
                      confirm_password: e.target.value,
                    })
                  }
                />
              </div>
            </div>

            <div className="mt-3">
              <FeedbackMsg text={pwMsg.text} ok={pwMsg.ok} />

              <button
                className="btn btn-primary"
                onClick={savePassword}
                disabled={pwSaving}
              >
                Update Password
              </button>
            </div>
          </SectionCard>
        </>
      )}
    </div>
  );
}
